/* eslint-disable comma-dangle */
import api, { headerNoAuth } from '../apiConfig';
import { retrieveCompanyName } from '../../routerPagesManager/routerPagesManager';

class LoginAPI {
  static verifyDomain() {
    const companyName = retrieveCompanyName();
    if (companyName === 'localhost') {
      return false;
    }
    return companyName;
  }

  static getLoginCompanyData() {
    const companyName = retrieveCompanyName();
    const protocol = companyName.endsWith('-st') ? 'http' : 'https';
    return api.get(
      `${protocol}://${companyName}.${process.env.REACT_APP_API}/login`,
      { headers: headerNoAuth() }
    );
  }

  static postLogin(authData) {
    return api.post('/login/', authData, {
      headers: headerNoAuth(),
    });
  }

  static postLoginResetPasswordNoAuth(email) {
    return api.post('/reset/password', email, {
      headers: headerNoAuth(),
    });
  }

  static patchLoginResetPasswordWithToken(user) {
    return api.patch('/users/password', user, {
      headers: headerNoAuth(),
    });
  }
}

export default LoginAPI;
